import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { ApplicationState } from '../../../../../store';
import BeforeTravelDocumentsDashboard, { IDispatchProps, IProps } from './index';
import { closeModal, openFollowUpDocumentModal, openUploadFollowUpModal } from '../../../../../store/ui/actions';
import { approveDoc } from '../../../../../store/student/followUpDocuments/actions';
import { SectionStatusType } from 'api-paths-cas';
import { saveFollowUpDocumentsShareCode } from '../../../../../store/student/actions';
import { hasAnyMatchingFollowUpDocs } from '../../../../../utilities/documents';

const mapStateToProps = (state: ApplicationState): IProps => {
  const isBeforeArrivalAreaHidden =
    state.student.config?.beforeArrivalDocAreaStatus === SectionStatusType.INACTIVE &&
    !state.student.summary.isBeforeTravelDocsStarted;

  const { followUpDocuments } = state.student;

  const hasRequiredBeforeTravelDocs = hasAnyMatchingFollowUpDocs(followUpDocuments, 'beforeTravel', 'required');
  const hasStaffOnlyBeforeTravelDocs = hasAnyMatchingFollowUpDocs(followUpDocuments, 'beforeTravel', 'staffOnly');
  const hasAgentOnlyBeforeTravelDocs = hasAnyMatchingFollowUpDocs(followUpDocuments, 'beforeTravel', 'agentOnly');

  return {
    hasRequiredBeforeTravelDocs,
    hasStaffOnlyBeforeTravelDocs,
    hasAgentOnlyBeforeTravelDocs,
    openModal: state.ui.openModal,
    documents: followUpDocuments,
    userRole: state.auth.role,
    serviceProviderType: state.auth.serviceProviderType,
    dob: state.student.personalInfo.dob,
    isBeforeArrivalAreaHidden,
    beforeDocumentsRequired: state.student.summary.beforeTravelDocsRequired,
  };
};

const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
  openFollowUpModal: (
    sponsorType: string,
    sponsorKey: string | null,
    docType: string | null,
    docKey: string | null,
    modalTitle?: string,
    data?: Record<string, unknown>,
  ): void => {
    dispatch(openFollowUpDocumentModal(sponsorType, sponsorKey, docType, docKey, modalTitle, data));
  },
  onApproveDoc: (
    sponsorType: string,
    sponsorKey: string | null,
    docType: string | null,
    docKey: string | null,
    docStatus?: string,
    docPrevStatus?: string,
  ): void => {
    dispatch(approveDoc(sponsorType, sponsorKey, docType, docKey, docStatus, docPrevStatus));
  },
  openUploadModal: (
    sponsorType: string | null,
    sponsorKey: string | null,
    docType: string | null,
    docKey: string | null,
    modalTitle: string,
    fileNames: string[],
    metadata?: unknown,
  ): void => {
    dispatch(openUploadFollowUpModal(sponsorType, sponsorKey, docType, docKey, modalTitle, fileNames, metadata));
  },
  closeModal: (): void => {
    dispatch(closeModal());
  },
  saveShareCode: (docKey: string, data: Record<string, unknown>): void => {
    dispatch(saveFollowUpDocumentsShareCode(docKey, data));
    dispatch(closeModal());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(BeforeTravelDocumentsDashboard);
